import AmenityView from './AmenityView'


export default AmenityView
